import { render } from "./TheBookFooter.vue?vue&type=template&id=a82f3902&scoped=true"
import script from "./TheBookFooter.vue?vue&type=script&lang=js"
export * from "./TheBookFooter.vue?vue&type=script&lang=js"

import "./TheBookFooter.vue?vue&type=style&index=0&id=a82f3902&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a82f3902"

export default script